var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { staticClass: "modal-h1 mb-3" }, [
      _c("button", {
        staticClass: "btn btn-back",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            _vm.$emit("cancel")
          }
        }
      }),
      _vm._v("\n    Create Truck\n  ")
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        attrs: { autocomplete: "no" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.create($event)
          },
          keydown: function($event) {
            _vm.clearError($event)
          }
        }
      },
      [
        _c("div", { staticClass: "l-bg-white" }, [
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Truck name")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.truck.name,
                        expression: "truck.name"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Enter Name" },
                    domProps: { value: _vm.truck.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.truck, "name", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "name" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Licence plate")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.truck.licence_plate,
                        expression: "truck.licence_plate"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Enter Licence Plate" },
                    domProps: { value: _vm.truck.licence_plate },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.truck,
                          "licence_plate",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "licence_plate" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("Size")]),
                    _vm._v(" "),
                    _c("simple-select", {
                      attrs: {
                        options: _vm.truck_sizes,
                        placeholder: "Select Size"
                      },
                      model: {
                        value: _vm.truck.truck_size_id,
                        callback: function($$v) {
                          _vm.$set(_vm.truck, "truck_size_id", $$v)
                        },
                        expression: "truck.truck_size_id"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "truck_size_id" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Seats")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.truck.number_of_seats,
                        expression: "truck.number_of_seats"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Enter No of Seats" },
                    domProps: { value: _vm.truck.number_of_seats },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.truck,
                          "number_of_seats",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "number_of_seats" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _vm.carriers && _vm.carriers.length
              ? _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "div",
                      { staticClass: "select-wrap" },
                      [
                        _c("label", [_vm._v("Carrier")]),
                        _vm._v(" "),
                        _c("simple-select", {
                          attrs: {
                            options: _vm.carriers,
                            placeholder: "Select Carrier"
                          },
                          model: {
                            value: _vm.truck.carrier_id,
                            callback: function($$v) {
                              _vm.$set(_vm.truck, "carrier_id", $$v)
                            },
                            expression: "truck.carrier_id"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "carrier" }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Make")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.truck.make,
                        expression: "truck.make"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Enter Make" },
                    domProps: { value: _vm.truck.make },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.truck, "make", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "make" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Model")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.truck.model,
                        expression: "truck.model"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Enter Model" },
                    domProps: { value: _vm.truck.model },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.truck, "model", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "model" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Year")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.truck.year,
                        expression: "truck.year"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Enter Year" },
                    domProps: { value: _vm.truck.year },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.truck, "year", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "year" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Zip")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.truck.zip,
                        expression: "truck.zip"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Enter Zip Code" },
                    domProps: { value: _vm.truck.zip },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.truck, "zip", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "zip" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary float-right ld-ext-right",
                  class: _vm.loadingButton ? "running" : "",
                  attrs: { disabled: _vm.buttonDisabled }
                },
                [
                  _vm._v("\n            Create\n            "),
                  _c("div", { staticClass: "ld ld-ball ld-flip" })
                ]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c803adea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c803adea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trucks/TrucksCreate.vue
// module id = null
// module chunks = 